import { render, staticRenderFns } from "./EditSO.vue?vue&type=template&id=3700f6b2&"
import script from "./EditSO.vue?vue&type=script&lang=js&"
export * from "./EditSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports